import UserIcon from "@gaiaProfessionals/Icons/UserIcon";
import Icon from "@insite/mobius/Icon";
import Link from "@insite/mobius/Link";
import React, { RefObject } from 'react'

interface AccountProps {
  accountMenuParentRef: RefObject<HTMLLIElement>;
}

const NavSignIn: React.FC<{account: AccountProps}> = ({account}) => {

  const { accountMenuParentRef } = account
  return (
    <li className="iconBlock__item iconBlock__item--account-notSignedIn" ref={accountMenuParentRef}>
      <div className="iconBlock__iconWrap">
        <Link className="iconBlock__link iconButton" href="/SignIn">
          <Icon className="iconBlock__icon iconBlock__icon--account" src={UserIcon} aria-hidden="true"></Icon>
          <span className="iconBlock__signInText">Sign-In</span>
        </Link>
        <span className="iconBlock__signInText">&nbsp;or&nbsp;</span>
        <Link className="iconBlock__link" href="/MyAccount/CreateAccount">
          <span className="iconBlock__signInText">Register</span>
        </Link>
      </div>
    </li>
  )
}

export default NavSignIn